export const iconFontAwesomeWritingBookmark = (
	<i className="fa-solid fa-bookmark"></i>
);
